import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CookieComponent } from './cookie.component';
import { LanguageInterceptor } from '../shared/language-interceptor.service';


@NgModule({
  providers:[LanguageInterceptor],
  imports: [
    RouterModule.forChild([
      { path: ':language/privacy-cookies-policy', component:CookieComponent, canActivate:[LanguageInterceptor], data:{localeTag: 'COOKIES_POLICY_URL'}},
      { path: ':language/politica-privacidad-cookies', component:CookieComponent, canActivate:[LanguageInterceptor], data:{localeTag: 'COOKIES_POLICY_URL'}},
      { path: ':language/politique-confidentialite-et-cookies', component:CookieComponent, canActivate:[LanguageInterceptor], data:{localeTag: 'COOKIES_POLICY_URL'}},
      { path: ':language/informativa-privacy-e-cookies', component:CookieComponent, canActivate:[LanguageInterceptor], data:{localeTag: 'COOKIES_POLICY_URL'}},
      { path: ':language/datenschutzbestimmungen-zur-verwendung-von-cookies', component:CookieComponent, canActivate:[LanguageInterceptor], data:{localeTag: 'COOKIES_POLICY_URL'}},
    ])
  ]
})
export class CookieRoutingModule { 

    
}
